<h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Projekte</h2>
<clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'cid_project_id'">Projektnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde</clr-dg-column>
    <clr-dg-column [clrDgField]="'request_id'">Anfrage des Kunden</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">Bestellnummer des Kunden</clr-dg-column>
    <clr-dg-column [clrDgField]="'budget'">Budget (netto)</clr-dg-column>
    <clr-dg-column [clrDgField]="'start_project'">Start</clr-dg-column>
    <clr-dg-column [clrDgField]="'end_project'" [clrDgSortOrder]="descSort">Ende</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Project!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let project of projects" [routerLink]="['/project/details', project.cid, project.id_project]">
        <clr-dg-cell>{{ project.cid_project_id }}</clr-dg-cell>
        <clr-dg-cell><b>{{ project.name_project }}</b></clr-dg-cell>
        <clr-dg-cell>{{ project.company_name }}</clr-dg-cell>
        <clr-dg-cell>{{ project.request_id }}</clr-dg-cell>
        <clr-dg-cell>{{ project.order_id }}</clr-dg-cell>
        <clr-dg-cell class="currency">{{ project.budget | currency: 'EUR':'code':'1.2-2':'de' }}</clr-dg-cell>
        <clr-dg-cell>{{ formatProjectDate(project.start_project) }}</clr-dg-cell>
        <clr-dg-cell>{{ formatProjectDate(project.end_project) }}</clr-dg-cell>
        <clr-dg-cell [className]="findButtonClass(project.status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <span class="alert-text">
                      @if (project?.status) {
                        {{ getCellStatus(project.status)?.statusDisplay }}
                      } @else {
                        Unbekannt
                      }
                    </span>
                </div>
            </div>
        </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Projekte pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von {{projects.length}} Projekt(en)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>
